/**
 * @generated SignedSource<<899a12080829f6fff5c0b12705e8b8d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithSocial_shoppingWith$data = {
  readonly mainImage: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "ShoppingWithSocial_shoppingWith";
};
export type ShoppingWithSocial_shoppingWith$key = {
  readonly " $data"?: ShoppingWithSocial_shoppingWith$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithSocial_shoppingWith">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShoppingWithSocial_shoppingWith",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "ShoppingWith",
  "abstractKey": null
};

(node as any).hash = "8a7f18d6e2fd82dd68041ab51b2639af";

export default node;
